/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
document.addEventListener('DOMContentLoaded', function() {
  // Get all elements with class "tab-link"
  const tabLinks = document.querySelectorAll('.tab-link');

  // Find the current tab-link element
  let currentTabLink = null;
  for (let i = 0; i < tabLinks.length; i++) {
    const tabLink = tabLinks[i];
    if (tabLink.classList.contains('current')) {
      currentTabLink = tabLink;
      break;
    }
  }

  if (currentTabLink) {
    // Get the tab-link number (e.g. 1, 2, 3) from the "tab-link-x" class
    const tabLinkClasses = currentTabLink.className.split(' ');
    let tabLinkNum = '';
    for (let j = 0; j < tabLinkClasses.length; j++) {
      const className = tabLinkClasses[j];
      if (className.startsWith('tab-link-')) {
        tabLinkNum = className.replace('tab-link-', '');
        break;
      }
    }

    // Find the corresponding tab-copy element and add the "current" class
    const currentTabCopy = document.querySelector(`.tab-copy-${tabLinkNum}`);
    if (currentTabCopy) {
      currentTabCopy.classList.add('current');
    }
  }

  // Loop through each tab-link element and add a click event listener
  for (let i = 0; i < tabLinks.length; i++) {
    const tabLink = tabLinks[i];

    tabLink.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default link behavior

      // Remove "current" class from all tab-links
      for (let j = 0; j < tabLinks.length; j++) {
        const otherTabLink = tabLinks[j];
        otherTabLink.classList.remove('current');
      }

      // Add "current" class to clicked tab-link
      tabLink.classList.add('current');

      // Get the tab-link number (e.g. 1, 2, 3) from the "tab-link-x" class
      const tabLinkClasses = tabLink.className.split(' ');
      let tabLinkNum = '';
      for (let j = 0; j < tabLinkClasses.length; j++) {
        const className = tabLinkClasses[j];
        if (className.startsWith('tab-link-')) {
          tabLinkNum = className.replace('tab-link-', '');
          break;
        }
      }

      // Find the corresponding tab-copy element and add the "current" class
      const tabCopy = document.querySelector(`.tab-copy-${tabLinkNum}`);
      if (tabCopy) {
        // Remove "current" class from all tab-copies
        const tabCopies = document.querySelectorAll('.tab-copy');
        for (let j = 0; j < tabCopies.length; j++) {
          const otherTabCopy = tabCopies[j];
          otherTabCopy.classList.remove('current');
        }

        tabCopy.classList.add('current');
      }
    });
  }

  // CHANGE THE PLACEHOLDER TEXT OF THE EMAIL INPUT FIELD ON THE HOMEPAGE NEWSLETTER FORM
  
  // Get the input element by its class name
  var emailInput = document.getElementsByClassName("newsletter-email-field")[0];

  if ( emailInput ) {
    // Change the placeholder text
    emailInput.placeholder = "Enter your email";
  }
  
});


})();


// Globo Product Options functionality
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const imageUrlInput = document.querySelector('input[name="image-url"]');
        
        if (imageUrlInput) {
          const placeholder = imageUrlInput.getAttribute('placeholder');
          
          if (placeholder) {
            const image = document.createElement('img');
            image.src = placeholder;
            image.classList.add('engraving-image'); // Add the class
          
            imageUrlInput.parentElement.insertBefore(image, imageUrlInput);
            imageUrlInput.remove();
            
            observer.disconnect();
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


// Add margins to prev/next buttons in Flickity Slider
document.addEventListener('DOMContentLoaded', function() {
  // Get the necessary elements
  const heroSlider = document.querySelector('.index-hero .slideshow__slider');
  const nextButton = document.querySelector('.flickity-prev-next-button.next');
  const prevButton = document.querySelector('.flickity-prev-next-button.previous');

  if ( heroSlider ) {
    // Add event listeners to the hero slider
    heroSlider.addEventListener('mouseover', function() {
      // Add margins left and right when the user hovers over the slider
      prevButton.style.marginLeft = '10px';
      nextButton.style.marginRight = '10px';
    });
  
    heroSlider.addEventListener('mouseout', function() {
      // Remove the margins when the user moves the mouse away from the slider
      prevButton.style.marginLeft = '0';
      nextButton.style.marginRight = '0';
    });
  }

});
// Show/hide collection page SEO copy
document.addEventListener("DOMContentLoaded", function() {
  const showMoreText = document.getElementById("show-more-text");
  const textElipsis = document.getElementById("elipsis");
  const showMoreButton = document.getElementById("show-more-button");

  // Check if elements exist before accessing their properties
  if (showMoreText && textElipsis && showMoreButton) {
    if (showMoreText.textContent.trim() !== '') {
      textElipsis.style.display = "inline";
    }

    showMoreButton.addEventListener('click', function() {
      toggleReadMore();
    });
  }
});

function toggleReadMore() {
  const initialText = document.getElementById("initial-text");
  const showMoreButton = document.getElementById("show-more-button");
  const showMoreText = document.getElementById("show-more-text");
  const textElipsis = document.getElementById("elipsis");

  if (showMoreText && textElipsis && showMoreButton) {
    const isExpanded = showMoreText.style.display === "none";
    console.log(isExpanded)
  
    if (isExpanded) {
      showMoreText.style.display = "inline";
      textElipsis.style.display = "none";
      showMoreButton.textContent = "See less";
    } else {
      showMoreText.style.display = "none";
      textElipsis.style.display = "inline";
      showMoreButton.textContent = "See more";
    }
  }
}


window.addEventListener("DOMContentLoaded", function() {
  
  // Check if the element with id "lookbook-container" exists
  var lookbookContainer = document.getElementById('lookbook-container');

  // Check if the element exists and if it is empty
  if (lookbookContainer && lookbookContainer.innerHTML.trim() === '') {
    // If the element is empty, remove height and margin-top properties
    lookbookContainer.style.height = '';
    lookbookContainer.style.marginTop = '';
  }
  
})

// add classes for SchemaPlus for FAQs
document.addEventListener('DOMContentLoaded', function() {
  const faqContainer = document.querySelector('.faq');

  if (faqContainer) {
    const accordionTitles = faqContainer.querySelectorAll('.accordion__title');
    const accordionBodies = faqContainer.querySelectorAll('.accordion__body p');

    accordionTitles.forEach(function(title) {
      title.classList.add('schemaplus_faq_question');
    });

    accordionBodies.forEach(function(body) {
      body.classList.add('schemaplus_faq_answer');
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
    // Function to remove the section
    function removeSection() {
        var sectionToRemove = document.querySelector('.CustomHtml--template--15216351510611__custom_html_PCbNeW');
        if (sectionToRemove) {
            sectionToRemove.remove();
            observer.disconnect(); // Disconnect the observer once the section is removed
        }
    }

    // Create a MutationObserver to observe changes in the DOM
    var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            // Check if the button is now available in the DOM
            if (mutation.target && mutation.target.querySelector('[data-qa="submit-button deep-purple-submit-button"]')) {
                // If the button is found, remove the section and disconnect the observer
                removeSection();
            }
        });
    });

    // Start observing changes in the DOM
    observer.observe(document.body, { childList: true, subtree: true });
});

//hide image on collections page if doesn't exist
document.addEventListener("DOMContentLoaded", function () {
  const img = document.querySelector('img[src*="stoned-heartlock.svg"]');

  if (img) {
    // Hide #alttext-container if image fails to load
    img.onerror = () => {
      const container = document.querySelector('#alttext-container');
      if (container) {
        container.style.display = 'none';
      }
    };

    // Also check if the image is already broken when this runs
    if (!img.complete || img.naturalWidth === 0) {
      const container = document.querySelector('#alttext-container');
      if (container) {
        container.style.display = 'none';
      }
    }
  }
});
// show horizontal divider in mobile menu
document.querySelectorAll('.sliderow__title').forEach(el => {
  if (el.textContent.trim().toLowerCase() === 'divider') {
    const wrapper = el.closest('.sliderule__wrapper');
    if (wrapper) {
      const divider = document.createElement('div');
      divider.className = 'menu-divider';
      wrapper.replaceWith(divider);
    }
  }
});
// color bottom module in mobile menu
let foundBottomModule = false;
let firstBottomApplied = false;

document.querySelectorAll('.sliderow__title').forEach(el => {
  const wrapper = el.closest('.sliderule__wrapper');

  if (!foundBottomModule && el.textContent.trim().toLowerCase() === 'bottom module') {
    foundBottomModule = true;
    if (wrapper) wrapper.style.display = 'none';
    return;
  }

  if (foundBottomModule && wrapper) {
    wrapper.classList.add('bottom-module-section');

    if (!firstBottomApplied) {
      wrapper.classList.add('bottom-module--first');
      firstBottomApplied = true;
    }
  }

  // Font weight logic
  if (wrapper) {
    if (wrapper.querySelector('.mobile__menu__dropdown')) {
      el.classList.add('menu-title--bold');
    } else {
      el.classList.remove('menu-title--bold');
    }
  }
});

// Mark the LAST top-level bottom module
const topLevelBottomModules = document.querySelectorAll(
  '.drawer__menu > .sliderule__wrapper.bottom-module-section'
);
if (topLevelBottomModules.length > 0) {
  topLevelBottomModules[topLevelBottomModules.length - 1].classList.add('bottom-module--last');
}

// If a product FAQ module exists on the page, hide the general page FAQ module
  document.addEventListener("DOMContentLoaded", function () {
    // check if the PDP FAQ module exists
    var pdpFaq = document.querySelector(".pdp-faq-module");
    var pageFaq = document.querySelector(".page-faq-module");

    if (pdpFaq && pageFaq) {
      pageFaq.style.display = "none";
    }
  });
// collections page - close filter
  document.addEventListener('click', function (event) {
    const closeBtn = event.target.closest('[data-collection-sidebar-close]');
    if (!closeBtn) return;

    event.preventDefault();

    const sidebar = document.querySelector('[data-collection-sidebar]');
    if (!sidebar) return;

    sidebar.classList.remove('expanded');
  });
// collections page - reinitialize open/close functionality on filter
document.addEventListener('click', (e) => {
  const heading = e.target.closest('[data-collection-sidebar-heading]');
  if (!heading) return;

  const group = heading.closest('.collection__sidebar__group');
  if (!group) return;

  const list = group.querySelector('.collection-nav');
  if (!list) return;

  const isOpen = heading.classList.toggle('is-active');

  // Use inline display so it behaves like the older theme
  list.style.display = isOpen ? '' : 'none';
});
// Expand/collapse "More options" within a filter group
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-show-more]');
    if (!btn) return;

    e.preventDefault();

    const group = btn.closest('.collection__sidebar__group');
    if (!group) return;

    // Items that are hidden past the first 10
    const hiddenItems = group.querySelectorAll('li[data-link-hidden].is-hidden');

    // First click: reveal all and switch to "Show less"
    if (hiddenItems.length) {
      hiddenItems.forEach(li => li.classList.remove('is-hidden'));
      btn.setAttribute('aria-expanded', 'true');
      btn.dataset.state = 'expanded';
      btn.textContent = btn.dataset.hideText || 'Show less';
      return;
    }

    // Second click: collapse back to 10 and switch to "Show more"
    const allItems = [...group.querySelectorAll('li[data-link-hidden]')];
    allItems.forEach((li, idx) => {
      if (idx >= 0) li.classList.add('is-hidden'); // hide all first
    });
    // …then unhide the first 0–9? We only hide those marked data-link-hidden,
    // so the first 10 are already without that attribute.
    btn.setAttribute('aria-expanded', 'false');
    btn.dataset.state = 'collapsed';
    btn.textContent = btn.dataset.showText || 'More options';
  }, { passive: false });
  
// collection page - change price filters to list
document.addEventListener('change', (e) => {
  const bucket = e.target.closest('.price-buckets input');
  if (!bucket) return;

  // Build new URL params from current URL
  const url = new URL(window.location.href);
  const params = url.searchParams;

  // Remove the custom param so it doesn't clutter the URL
  params.delete('price_bucket');

  // Set Shopify price filter params
  const min = bucket.dataset.min;
  const max = bucket.dataset.max;

  if (min) params.set('filter.v.price.gte', min);
  else params.delete('filter.v.price.gte');

  if (max) params.set('filter.v.price.lte', max);
  else params.delete('filter.v.price.lte');

  // Reload with proper Shopify filter params
  url.search = params.toString();
  window.location.href = url.toString();
});

// Optional: clear button support
document.addEventListener('click', (e) => {
  const clear = e.target.closest('.price-buckets__clear');
  if (!clear) return;

  const url = new URL(window.location.href);
  url.searchParams.delete('filter.v.price.gte');
  url.searchParams.delete('filter.v.price.lte');
  url.searchParams.delete('price_bucket');

  window.location.href = url.toString();
});
function syncPriceBucketsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const gte = params.get('filter.v.price.gte') || '';
  const lte = params.get('filter.v.price.lte') || '';

  const buckets = document.querySelectorAll('.price-buckets input[data-min], .price-buckets input[data-max]');
  if (!buckets.length) return;

  // Clear all first
  buckets.forEach(b => { b.checked = false; });

  // Find an exact match (string compare is fine; normalize just in case)
  const norm = (v) => (v == null ? '' : String(v).trim());

  const g = norm(gte);
  const l = norm(lte);

  let matched = false;

  buckets.forEach(b => {
    const bMin = norm(b.dataset.min || '');
    const bMax = norm(b.dataset.max || '');

    if (bMin === g && bMax === l) {
      b.checked = true;
      matched = true;
    }
  });

  // Optional: if only max is set (Under $500), match that
  if (!matched && l && !g) {
    buckets.forEach(b => {
      const bMin = norm(b.dataset.min || '');
      const bMax = norm(b.dataset.max || '');
      if (!bMin && bMax === l) b.checked = true;
    });
  }

  // Optional: if only min is set ($5,000+), match that
  if (!matched && g && !l) {
    buckets.forEach(b => {
      const bMin = norm(b.dataset.min || '');
      const bMax = norm(b.dataset.max || '');
      if (bMin === g && !bMax) b.checked = true;
    });
  }
}

document.addEventListener('DOMContentLoaded', syncPriceBucketsFromUrl);















  







